import {Component, OnInit} from '@angular/core';

import {Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {User} from '../../_models/index';

import {Role} from '../../helpers/role';
import {LoginHelper} from '../../helpers';

@Component({
    standalone: false,
  selector: "invite-user",
  templateUrl: 'invite.user.component.html'
})

export class InviteUserComponent implements OnInit {
  model: any = {};
  loading = false;
  currentUser: User;
  userRoles: Role[];
  selectedRole: Role = Role.Training;

  constructor(
    public router: Router,
    public userService: UserService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService) {
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

        if ((this.currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0) {
      this.userRoles = [Role.User, Role.Vendor, Role.Training];
    } else if ((this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0) {
      this.userRoles = [Role.AdvisorStaff, Role.Vendor, Role.Training];
    } else {
      this.userRoles = [Role.Training];
    }

    this.selectedRole = this.userRoles[0];
  }

  getRole(role: number): string {

    let roleStr = '';

    if ((role & (Role.Manager | Role.PrimaryManager)) != 0) {
      roleStr = 'Manager'
    } else if ((role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0) {
      roleStr = 'Advisor Lead'
    } else if ((role & Role.KingAdmin) != 0) {
      roleStr = 'King Admin'
    } else {
      roleStr = Role[role];
    }



    return roleStr;
  }

  onInvite() {
    this.loading = true;
    let tenantName = LoginHelper.getTenantName();
    const users = this.model.emailAddresses.match(/[^\r\n,; ]+/g).map(e => {
      return {
        tenantName: tenantName,
        role: Role.Training,
        emailAddress: e
      }
    });

    this.userService.createManyAwareness(users, tenantName)
      .subscribe(
        data => {
          if (data.error) {
            this.alertService.error(data.error);
          } else {
            this.alertService.success('Awareness users sucessfully registered', true);
            this.router.navigate(['/users']);
          }
        },
        error => {
          const errorMessage = 'An error occurred while inviting users.';
          this.alertService.error((error || {})._body || errorMessage);
          this.loading = false;
        });
  }
}
